/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyV2Recommendation {
    getFixupPrototypeFunction() { return PolicyV2Recommendation.fixupPrototype; }

    static newInstance(model: Partial<PolicyV2Recommendation>): PolicyV2Recommendation {
        let obj = Object.assign(new PolicyV2Recommendation(), model);
        PolicyV2Recommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyV2Recommendation>): PolicyV2Recommendation {
        if (!model) return null;
        return PolicyV2Recommendation.newInstance(<PolicyV2Recommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyV2Recommendation) {
        if (!obj) return;

        models.PolicyV2Recommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyV2Recommendation): boolean {
        Object.setPrototypeOf(obj, PolicyV2Recommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.actions) {
            for (let val of this.actions) {
                models.RecommendationAction.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the recommendation
     */
    name: string;

    /**
     * Description of the recommendation
     */
    description: string;

    /**
     * Impact of the recommended changes
     */
    impact: models.PolicyRecommendationImpactType;

    /**
     * List of actions to resolve policy violations
     */
    actions: Array<models.RecommendationAction>;

}
